import SubscriptionsScreen from './SubscriptionsScreen';

export default SubscriptionsScreen;